import React, { useEffect, useState } from 'react'
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Row from 'react-bootstrap/Row';
import { Button as ButtonB } from 'react-bootstrap';
import * as formik from 'formik';
import * as yup from 'yup';
import {
    Button,
    Text,
    Loader,
    View,
} from "@aws-amplify/ui-react";
import { API, Auth } from "aws-amplify";
import axios from 'axios';
import { publishMessage } from '../../graphql/mutations';
import { onMessageReceived } from '../../graphql/subscriptions';
import '../../App.css'

export default function FormGases() {
    const [isLoading, setIsLoading] = useState(false);
    const [infoRFC, setInfoRFC] = useState(false);
    const { Formik } = formik;

    const schema = yup.object().shape({
        RFC: yup.string().required("Este Campo es Obligatorio").matches(/^[A-Za-z]{4}\d{9}$/, 'RFC inválido'),
        PeriodoInicial: yup.string().required("Este Campo es Obligatorio"),
        PeriodoFinal: yup.string().required("Este Campo es Obligatorio"),
        BC: yup.string().required("Este Campo es Obligatorio"),
        MET: yup.string().required("Este Campo es Obligatorio"),
        OXI: yup.string().required("Este Campo es Obligatorio"),
        /* TipoDeGas: yup.string().required("Este Campo es Obligatorio"),
        CantidadGas: yup.string().required("Este Campo es Obligatorio"), */
        PagosPro: yup.string().required("Este Campo es Obligatorio"),
        SaldoFavor: yup.string(),
        Compensacion: yup.string(),
        Multas: yup.string(),
    });

    const payTransaction = async (tranData) => {
        setIsLoading(true);
        const paymentProcess = await callLambdaFunction();
        console.log(paymentProcess);
        const data = {
            tramite: 'Tramite 1--',
            amount: 0.0,
            status: 'Procesando',
            paymenturl: 'Not Set'//paymentSam.data.url,
        };
        const user = await Auth.currentAuthenticatedUser();
        data.owner = user.username; // Set the owner's ID
        const sendDataPayment = {

            gases: [
                {

                    clave: tranData.TipoDeGas,

                    cantidad: Number(tranData.CantidadGas),

                }
            ],
            "transaccion": {

                "owner": user.username,

                "tramite": "Tramite - 1"

            }

        };
        const paymentSam = await paymentCall(sendDataPayment);
        console.log("DTAA SAM", paymentSam);
        window.open(paymentSam.data.url)
        setIsLoading(false);
    };
    async function paymentCall(data) {
        const urlPayment = 'https://5r0aarz3je.execute-api.us-west-2.amazonaws.com/Prod/servicios/stripe/create-checkout-session';

        try {
            const response = await axios.post(urlPayment,
                data);
            console.log("Response", response);
            return response
        } catch (error) {
            console.log("Response - Error", error);
            return error
        }
    }

    async function callLambdaFunction() {
        try {
            const response = await API.post('apiActions', '/api', {
                body: { /* data */ },
            });
            console.log('Lambda response:', response);
            return response
        } catch (error) {
            console.error('Lambda error:', error);
            return error
        }
    }
    const validarRFC = async (RFC) => {
        let user = await Auth.currentAuthenticatedUser();
        /*const Data = await  API.graphql({
            query: publishMessage,
            variables: {
                id:'IECSA',
                payload: {
                    taskToken: "token",
                    authToken: "token",
                    paymentMethod:'card',
                    email:user.email,
                    tramite:'IMPUESTO AL ALMACENAMIENTO DE RESIDUOS',
                    referencia:'',
                    monto:'',
                }
            },

        });*/
        const payload = {
            id:'IECSA',
            validationRequested:true,
            data:{
                rfc:'MOOA910828HM8'
            }
        }
        const Data = await  API.graphql({
            query: publishMessage,
            variables: {
                id:'123',
                payload: JSON.stringify(payload),
            },

        });
        console.log("A VALIDATE", Data);
        /*axios.get(`https://test-api-durango-digital.durango.gob.mx/v1/padrones/gases/${RFC}`)
            .then(response => {
                setInfoRFC(response.data)
                console.log('Respuesta del servidor:', response.data);

            })
            .catch(error => {
                console.error('Error al hacer la petición:', error);
            });*/
    }

    const [message, setMessage] = useState(null);

  useEffect(() => {
    const subscription = API.graphql({query:onMessageReceived, variables: { id: '123' }})
      .subscribe({
        next: (event) => {
            console.log("MANAGE ",event.value.data);
          const receivedMessage = event.value.data.onMessageReceived;
          //parse json on payload response. - authToken - taskToken --- rfc
          setMessage(receivedMessage);
        },
        error: (error) => {
          console.error('Subscription error', error);
        },
      });

    return () => {
      subscription.unsubscribe();
    };
  }, []);
    return (
        <>
            <div className='HeaderTramite'>
                <View className='FormTitle'>Impuesto de la emisión de gases en la atmosfera</View>
                <View className='FormSubTitle'>Pago del impuesto de la emisión de gases en la atmosfera.</View>
                <View className='FormDescripcion'>
                    A personas fisicas, personas morales, unidades economicas y entidades gubernamentales que generen
                    emisiones de gases de efecto invernadero en sus procesos productivos y operaciones dentro del
                    territorio del Estado de Durango, México.
                </View>
            </div>
            <View className='ViewPrincipal'>
                <View className='FormContent'>

                    <Formik
                        validationSchema={schema}
                        onSubmit={(valores, { resetForm }) => {
                            console.log("Valores", valores);
                            /*  payTransaction(valores); */
                        }

                        }
                        initialValues={{
                            RFC: '',
                            PeriodoInicial: '',
                            PeriodoFinal: '',
                            BC: '',
                            MET: '',
                            OXI: '',
                            /*  TipoDeGas: '',
                             CantidadGas: '', */
                            PagosPro: '',
                            SaldoFavor: '',
                            Compensacion: '',
                            Multas: ''
                        }}
                    >
                        {({ handleSubmit, handleChange, values, touched, errors }) => (
                            <Form noValidate onSubmit={handleSubmit} className='ViewActa'>
                                <Row className="mb-3">
                                    <Form.Group
                                        as={Col}
                                        controlId="validationFormikRFC"
                                        className="position-relative"
                                    >
                                        <Form.Label style={{ fontFamily: "Helvetica", fontWeight: "700", color: "#2D3748", textDecoration: "underline" }}>
                                            RFC*
                                        </Form.Label>
                                        <InputGroup>
                                            <Form.Control
                                                type="text"
                                                name="RFC"
                                                value={values.RFC}
                                                onChange={handleChange}
                                                isValid={touched.RFC && !errors.RFC}
                                                isInvalid={!!errors.RFC && touched.RFC}
                                            />
                                            <Form.Control.Feedback type="invalid" tooltip>
                                                {errors.RFC}
                                            </Form.Control.Feedback>
                                            <ButtonB variant='secondary' onClick={() => validarRFC(values.RFC)}>Validar</ButtonB>
                                        </InputGroup>
                                    </Form.Group>

                                </Row>
                                {infoRFC.estatus ?

                                    <>
                                        <Row className="mb-3">

                                            <Form.Group
                                                as={Col}
                                                controlId="validationFormik102"
                                                className="position-relative"
                                            >
                                                <Form.Label style={{ fontFamily: "Helvetica", fontWeight: "700", color: "#2D3748", textDecoration: "underline" }}>Periodo Inicial*</Form.Label>
                                                <InputGroup hasValidation>
                                                    <Form.Control
                                                        type="date"
                                                        name="PeriodoInicial"
                                                        value={values.PeriodoInicial}
                                                        onChange={handleChange}
                                                        isValid={touched.PeriodoInicial && !errors.PeriodoInicial}
                                                        isInvalid={!!errors.PeriodoInicial && touched.PeriodoInicial}
                                                    />

                                                    <Form.Control.Feedback type="invalid" tooltip>{errors.PeriodoInicial}</Form.Control.Feedback>
                                                </InputGroup>
                                            </Form.Group>
                                            <Form.Group as={Col} controlId="validationFormikUsername2" className="postion-relative">
                                                <Form.Label style={{ fontFamily: "Helvetica", fontWeight: "700", color: "#2D3748", textDecoration: "underline" }}>Periodo Final*</Form.Label>
                                                <InputGroup hasValidation>
                                                    <Form.Control
                                                        type="date"
                                                        name="PeriodoFinal"
                                                        value={values.PeriodoFinal}
                                                        onChange={handleChange}
                                                        isValid={touched.PeriodoFinal && !errors.PeriodoFinal}
                                                        isInvalid={!!errors.PeriodoFinal && touched.PeriodoFinal}
                                                    />
                                                    <Form.Control.Feedback type="invalid" tooltip>
                                                        {errors.PeriodoFinal}
                                                    </Form.Control.Feedback>
                                                </InputGroup>
                                            </Form.Group>
                                        </Row>
                                        <Row className="mb-3">
                                            <Form.Label style={{ fontSize: "20px", fontFamily: "Helvetica", fontWeight: "700", color: "#2D3748", textDecoration: "underline" }}>Gases</Form.Label>
                                            <Form.Group as={Col} className='position-relative'>
                                                <Form.Label style={{ fontFamily: "Helvetica", fontWeight: "700", color: "#2D3748", textDecoration: "underline" }}>Dioxido de Carbono*</Form.Label>
                                                <Form.Control
                                                    type='number'
                                                    name='BC'
                                                    placeholder='Toneladas cubicas de Gas'
                                                    value={values.BC}
                                                    onChange={handleChange}
                                                    isValid={touched.BC && !errors.BC}
                                                    isInvalid={!!errors.BC && touched.BC}
                                                />
                                                <Form.Control.Feedback type='invalid' tooltip>{errors.BC}</Form.Control.Feedback>
                                            </Form.Group>
                                            <Form.Group as={Col} className='position-relative'>
                                                <Form.Label style={{ fontFamily: "Helvetica", fontWeight: "700", color: "#2D3748", textDecoration: "underline" }}>Metano*</Form.Label>
                                                <Form.Control
                                                    type='number'
                                                    placeholder='Toneladas cubicas de Gas'
                                                    name='MET'
                                                    value={values.MET}
                                                    onChange={handleChange}
                                                    isValid={touched.MET && !errors.MET}
                                                    isInvalid={!!errors.MET && touched.MET}
                                                />
                                                <Form.Control.Feedback type='invalid' tooltip>{errors.MET}</Form.Control.Feedback>
                                            </Form.Group>
                                            <Form.Group as={Col} className='position-relative'>
                                                <Form.Label style={{ fontFamily: "Helvetica", fontWeight: "700", color: "#2D3748", textDecoration: "underline" }}>Oxido Nitroso*</Form.Label>
                                                <Form.Control
                                                    type='number'
                                                    placeholder='Toneladas cubicas de Gas'
                                                    name='OXI'
                                                    value={values.OXI}
                                                    onChange={handleChange}
                                                    isValid={touched.OXI && !errors.OXI}
                                                    isInvalid={!!errors.OXI && touched.OXI}
                                                />
                                                <Form.Control.Feedback type='invalid' tooltip>{errors.OXI}</Form.Control.Feedback>
                                            </Form.Group>
                                            {/*           <Form.Group
                                                as={Col}
                                                controlId="validationFormik103"
                                                className="position-relative"
                                            >
                                                <Form.Label style={{ fontFamily: "Helvetica", fontWeight: "700", color: "#2D3748", textDecoration: "underline" }}>Tipo de Gas*</Form.Label>
                                                <Form.Select
                                                    name="TipoDeGas"
                                                    value={values.TipoDeGas}
                                                    onChange={handleChange}
                                                    isValid={touched.TipoDeGas && !errors.TipoDeGas}
                                                    isInvalid={!!errors.TipoDeGas && touched.TipoDeGas}
                                                >
                                                    <option>Seleccione</option>
                                                    <option value="BC">Dioxido de Carbono</option>
                                                    <option value="MET">Metano</option>
                                                    <option value="OXI">Oxido Nitroso</option>
                                                </Form.Select>

                                                <Form.Control.Feedback type="invalid" tooltip>
                                                    {errors.TipoDeGas}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                            <Form.Group
                                                as={Col}
                                                controlId="validationFormik104"
                                                className="position-relative"
                                            >
                                                <Form.Label style={{ fontFamily: "Helvetica", fontWeight: "700", color: "#2D3748", textDecoration: "underline" }}>Toneladas cubicas de Gas*</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="CantidadGas"
                                                    value={values.CantidadGas}
                                                    onChange={handleChange}
                                                    isValid={touched.CantidadGas && !errors.CantidadGas}
                                                    isInvalid={!!errors.CantidadGas && touched.CantidadGas}
                                                />
                                                <Form.Control.Feedback type="invalid" tooltip>
                                                    {errors.CantidadGas}
                                                </Form.Control.Feedback>
                                            </Form.Group> */}
                                        </Row>
                                        <Row className='mb-3'>
                                            <Form.Group as={Col} className='position-relative'>
                                                <Form.Label style={{ fontFamily: "Helvetica", fontWeight: "700", color: "#2D3748", textDecoration: "underline" }}>Pagos Provisionales*</Form.Label>
                                                <Form.Control
                                                    type='text'
                                                    name='PagosPro'
                                                    value={values.PagosPro}
                                                    onChange={handleChange}
                                                    isValid={touched.PagosPro && !errors.PagosPro}
                                                    isInvalid={!!errors.PagosPro && touched.PagosPro}
                                                />
                                                <Form.Control.Feedback type='invalid' tooltip>{errors.PagosPro}</Form.Control.Feedback>
                                            </Form.Group>
                                        </Row>
                                        <Row className='mb-3'>
                                            <Form.Group as={Col} className='position-relative'>
                                                <Form.Label style={{ fontFamily: "Helvetica", fontWeight: "700", color: "#2D3748", textDecoration: "underline" }}>
                                                    Saldo a Favor
                                                </Form.Label>
                                                <Form.Control
                                                    type='text'
                                                    name='SaldoFavor'
                                                    value={values.SaldoFavor}
                                                    onChange={handleChange}
                                                    isValid={touched.SaldoFavor && !errors.SaldoFavor}
                                                    isInvalid={!!errors.SaldoFavor && touched.SaldoFavor}
                                                />
                                                <Form.Control.Feedback type='invalid' tooltip>{errors.SaldoFavor}</Form.Control.Feedback>
                                            </Form.Group>
                                        </Row>
                                        <Row className='mb-3'>
                                            <Form.Group as={Col} className='position-relative'>
                                                <Form.Label style={{ fontFamily: "Helvetica", fontWeight: "700", color: "#2D3748", textDecoration: "underline" }}>
                                                    Compensación
                                                </Form.Label>
                                                <Form.Control
                                                    type='text'
                                                    name='Compensacion'
                                                    value={values.Compensacion}
                                                    onChange={handleChange}
                                                    isValid={touched.Compensacion && !errors.Compensacion}
                                                    isInvalid={!!errors.Compensacion && touched.Compensacion}
                                                />
                                                <Form.Control.Feedback type='invalid' tooltip>{errors.Compensacion}</Form.Control.Feedback>
                                            </Form.Group>
                                        </Row>
                                        <Row className='mb-3'>
                                            <Form.Group as={Col} className='position-relative'>
                                                <Form.Label style={{ fontFamily: "Helvetica", fontWeight: "700", color: "#2D3748", textDecoration: "underline" }}>Pagos Provisionales</Form.Label>
                                                <Form.Control
                                                    type='text'
                                                    name='Multas'
                                                    value={values.Multas}
                                                    onChange={handleChange}
                                                    isValid={touched.Multas && !errors.Multas}
                                                    isInvalid={!!errors.Multas && touched.Multas}
                                                />
                                                <Form.Control.Feedback type='invalid' tooltip>{errors.Multas}</Form.Control.Feedback>
                                            </Form.Group>
                                        </Row>
                                        <Row className="mb-3">
                                            <Form.Group as={Col} className="d-grid gap-2">
                                                <Text>Descripcion: Pulsa el boton para generar tu orden de pago.</Text>
                                                <Button type="submit" style={{ backgroundColor: "#607472", color: "white" }} isDisabled={isLoading}>
                                                    {isLoading ?
                                                        <>
                                                            Loading
                                                            <Loader
                                                            />
                                                        </>
                                                        :
                                                        <>
                                                            Siguiente
                                                            <svg width="20" height="20" viewBox="0 0 34 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M23.4209 18.537C23.5726 18.3785 23.6915 18.1916 23.7709 17.987C23.9376 17.5813 23.9376 17.1261 23.7709 16.7204C23.6915 16.5158 23.5726 16.3289 23.4209 16.1704L18.4209 11.1704C18.107 10.8565 17.6814 10.6802 17.2375 10.6802C16.7937 10.6802 16.368 10.8565 16.0542 11.1704C15.7404 11.4842 15.5641 11.9098 15.5641 12.3537C15.5641 12.7975 15.7404 13.2232 16.0542 13.537L18.2209 15.687H12.2375C11.7955 15.687 11.3716 15.8626 11.059 16.1752C10.7465 16.4877 10.5709 16.9117 10.5709 17.3537C10.5709 17.7957 10.7465 18.2196 11.059 18.5322C11.3716 18.8448 11.7955 19.0204 12.2375 19.0204H18.2209L16.0542 21.1704C15.898 21.3253 15.774 21.5096 15.6894 21.7127C15.6048 21.9158 15.5612 22.1337 15.5612 22.3537C15.5612 22.5737 15.6048 22.7915 15.6894 22.9946C15.774 23.1977 15.898 23.3821 16.0542 23.537C16.2091 23.6932 16.3935 23.8172 16.5966 23.9018C16.7997 23.9865 17.0175 24.03 17.2375 24.03C17.4576 24.03 17.6754 23.9865 17.8785 23.9018C18.0816 23.8172 18.2659 23.6932 18.4209 23.537L23.4209 18.537ZM33.9042 17.3537C33.9042 14.0573 32.9267 10.835 31.0954 8.09418C29.264 5.35336 26.661 3.21715 23.6156 1.95569C20.5702 0.694233 17.219 0.364178 13.986 1.00726C10.753 1.65035 7.7833 3.2377 5.45242 5.56857C3.12155 7.89945 1.5342 10.8692 0.891115 14.1022C0.248028 17.3352 0.578083 20.6863 1.83954 23.7317C3.101 26.7772 5.23721 29.3802 7.97803 31.2115C10.7189 33.0429 13.9412 34.0204 17.2375 34.0204C21.6578 34.0204 25.897 32.2644 29.0226 29.1388C32.1483 26.0132 33.9042 21.774 33.9042 17.3537ZM3.9042 17.3537C3.9042 14.7166 4.68619 12.1387 6.15127 9.94608C7.61636 7.75343 9.69874 6.04446 12.1351 5.03529C14.5714 4.02612 17.2523 3.76208 19.8387 4.27655C22.4252 4.79102 24.8009 6.06089 26.6656 7.9256C28.5303 9.7903 29.8002 12.1661 30.3147 14.7525C30.8291 17.3389 30.5651 20.0198 29.5559 22.4561C28.5468 24.8925 26.8378 26.9749 24.6451 28.4399C22.4525 29.905 19.8746 30.687 17.2375 30.687C13.7013 30.687 10.3099 29.2823 7.80945 26.7818C5.30896 24.2813 3.9042 20.8899 3.9042 17.3537Z" fill="white" />
                                                            </svg>
                                                        </>

                                                    }
                                                </Button>
                                            </Form.Group>
                                        </Row>
                                    </>
                                    :
                                    null

                                }
                                <Row className="mb-3">
                                    <Form.Group as={Col} className="d-grid gap-2">
                                        <Button type="button" variation="secondary">
                                            Regresar
                                        </Button>
                                    </Form.Group>

                                </Row>
                            </Form>
                        )}
                    </Formik>

                </View>
                {/*  <aside >
                        <seccion className="seccion1">
                            <span>Desgloce del importe a pagar</span>
                        </seccion>
                        <seccion className="seccion2">
                            <label>Conceptos</label>
                            <span>PAGO 1 <strong> $104.75</strong></span>
                            <span>PAGO 2 <strong> $41.75</strong></span>
                            <span>PAGO 3 <strong> $0.75</strong></span>
                            <span style={{ fontWeight: "bold" }}>TOTAL A PAGAR <strong> $147.25</strong></span>
                        </seccion>
                    </aside> */}

            </View>

        </>
    )
}
